import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Create axios instance for admin requests with JWT token + cookies
export const adminApi = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Add token to admin requests (backup for cookie-less environments)
adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("adminToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401/403 responses - redirect to admin login
adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem("adminToken");
      if (!window.location.pathname.startsWith("/admin")) {
        window.location.href = "/admin";
      }
    }
    return Promise.reject(error);
  }
);

// Public API (no auth, sends cookies for user context)
export const publicApi = axios.create({
  baseURL: API,
  withCredentials: true,
});
